/* =============================================================================
   Furniselan — colour derived products popup
   ============================================================================= */
(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, once = FS.once, T = FS.T, Overlay = FS.Overlay, formatMoney = FS.formatMoney;
  var cache = {};

  function modal() { return qs('[data-variant-popup]'); }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch((T.routes.root || '/') + 'products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed: HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) { cache[handle] = p; return p; });
  }

  /**
   * Fetch per-variant delivery data from the quick-view section which has
   * the embedded data-qv-delivery-map JSON. Falls back gracefully.
   */
  var deliveryCache = {};
  function fetchDeliveryMap(handle) {
    if (deliveryCache[handle]) return Promise.resolve(deliveryCache[handle]);
    var url = (T.routes.root || '/') + 'products/' + handle + '?view=quick-view&section_id=quick-view';
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) { deliveryCache[handle] = {}; return {}; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var el = tmp.querySelector('[data-qv-delivery-map]');
        if (!el) { deliveryCache[handle] = {}; return {}; }
        try {
          var map = JSON.parse(el.textContent);
          deliveryCache[handle] = map;
          return map;
        } catch(e) { deliveryCache[handle] = {}; return {}; }
      })
      .catch(function () { deliveryCache[handle] = {}; return {}; });
  }

  /** One representative variant per value of the colour option. */
  function colourVariants(product, optionIndex) {
    var seen = {}, out = [];
    product.variants.forEach(function (v) {
      var value = v.options[optionIndex];
      if (value == null || seen[value]) return;
      seen[value] = true;
      out.push({ value: value, variant: v });
    });
    return out;
  }

  function cardHTML(product, entry, fallbackTags, deliveryMap) {
    var v = entry.variant;
    var img = (v.featured_image && v.featured_image.src) || product.featured_image || '';
    if (img && img.indexOf('?') === -1) img += '?width=500';
    else if (img) img += '&width=500';

    var price = '<span class="variant-popup__price">' + formatMoney(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      // Use the same tag-based multiplier so discount % matches Collection Page, Quick View, and PDP
      var tagMult = 1.0;
      var tags = (product && product.tags && product.tags.length) ? product.tags : (fallbackTags || '');
      var tagString = Array.isArray(tags) ? tags.join(' ').toLowerCase() : String(tags || '').toLowerCase();
      if (tagString.indexOf('20off') > -1) tagMult = 1.25;
      else if (tagString.indexOf('15off') > -1) tagMult = 1.1764;
      else if (tagString.indexOf('10off') > -1) tagMult = 1.111;

      var regP = Math.round(v.price * tagMult);
      var pct = Math.round(((v.compare_at_price - regP) / v.compare_at_price) * 100);

      price += ' <s>' + formatMoney(v.compare_at_price) + '</s>';
      if (pct > 0) {
        price += ' <em>' + pct + '% ' + (T.strings.off || 'OFF') + '</em>';
      }
    }
    price += '</span>';

    // Delivery attributes for this variant
    var dMap = deliveryMap || {};
    var vDel = dMap[String(v.id)] || {};
    // readyStock: true/false = explicitly set, null/undefined = NOT set on this variant
    var rsVal = vDel.readyStock;
    var isReadyStockSet = rsVal === true || rsVal === false;
    var delMsg = vDel.message ? vDel.message.trim() : '';

    var atcAttrs = ' data-variant-id="' + v.id + '" data-product-handle="' + (product.handle || '') + '" data-is-variant-popup="true"';
    if (vDel.dimension) {
      atcAttrs += ' data-dimension-value="' + String(vDel.dimension).replace(/"/g, '&quot;') + '"';
    } else if (product.options) {
      for (var oI = 0; oI < product.options.length; oI++) {
        var oName = (typeof product.options[oI] === 'string' ? product.options[oI] : (product.options[oI].name || '')).toLowerCase();
        if (oName.indexOf('dimension') > -1 && v.options && v.options[oI]) {
          atcAttrs += ' data-dimension-value="' + String(v.options[oI]).replace(/"/g, '&quot;') + '"';
          break;
        }
      }
    }
    var deliveryZips = JSON.stringify(vDel.zips || [])
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
    atcAttrs += ' data-delivery-zips="' + deliveryZips + '"';
    if (isReadyStockSet) {
      atcAttrs += ' data-ready-stock="' + (rsVal ? 'true' : 'false') + '"';
      if (delMsg) atcAttrs += ' data-delivery-msg="' + delMsg.replace(/"/g, '&quot;') + '"';
    }

    var action = v.available
      ? '<button type="button" class="btn variant-popup__add" data-add-to-cart' + atcAttrs + '>' +
        (T.strings.addToCart || 'Add to Cart') + '</button>'
      : '<span class="variant-popup__sold">' + (T.strings.soldOut || 'Sold out') + '</span>';

    return '<div class="variant-popup__card">' +
      '<a class="variant-popup__media" href="' + product.url + '?variant=' + v.id + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
      '</a>' +
      '<a class="variant-popup__name" href="' + product.url + '?variant=' + v.id + '">' +
        product.title + ' - ' + entry.value +
      '</a>' +
      price + action +
    '</div>';
  }

  function open(handle, optionIndex, fallbackTags) {
    var box = modal(), body = box && qs('[data-variant-popup-body]', box);
    if (!box || !body) return;
    initVariantPopup();
    body.innerHTML = '<p class="quick-view__loading">' + (T.strings.loading || 'Loading…') + '</p>';
    Overlay.show(box);
    Promise.all([fetchProduct(handle), fetchDeliveryMap(handle)])
      .then(function (results) {
        var product = results[0];
        var deliveryMap = results[1];
        var entries = colourVariants(product, optionIndex);
        body.innerHTML = '<div class="rail-wrap">' +
          '<div class="rail rail--variants">' +
            entries.map(function (e) { return cardHTML(product, e, fallbackTags, deliveryMap); }).join('') +
          '</div>' +
          '<div class="rail-dots"></div>' +
        '</div>';
        // Hand the fresh markup to the theme's rail init so it gets the same
        // arrows, dots and swipe behaviour as every other carousel.
        if (window.Furniselan && window.Furniselan.init) window.Furniselan.init(body);
      })
      .catch(function (err) {
        if (window.console) console.error('Variant popup could not load:', err);
        body.innerHTML = '<p class="quick-view__error">' + (T.strings.quickViewError || "Couldn't load this product.") + '</p>';
      });
  }

  function initVariantPopup() {
    var box = modal();
    if (box && once(box, 'VariantPopup')) {
      var close = qs('[data-variant-popup-close]', box);
      if (close) close.addEventListener('click', function () { Overlay.hide(box); });
    }
  }

  // Global reliable backdrop/outside click and close button handler
  document.addEventListener('click', function (e) {
    var box = modal();
    if (!box || !box.classList.contains('is-open')) return;

    // 1. Close button clicked
    if (e.target.closest('[data-variant-popup-close]')) {
      e.preventDefault();
      Overlay.hide(box);
      return;
    }

    // 2. Click is inside the popup box -> do not close
    if (e.target.closest('.variant-popup__box')) {
      return;
    }

    // 3. Click is on swatch that opens popup -> do not close
    if (e.target.closest('[data-card-swatch]')) {
      return;
    }

    // 4. Click is outside -> CLOSE POPUP!
    Overlay.hide(box);
  }, true);

  // ESC key handler
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var box = modal();
      if (box && box.classList.contains('is-open')) {
        Overlay.hide(box);
      }
    }
  });

  document.addEventListener('click', function (e) {
    var target = e.target;
    var swatch = target && target.closest && target.closest('[data-card-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.product-card');
    if (!card || !card.dataset.productHandle || card.dataset.colorIndex == null) return;
    open(card.dataset.productHandle, parseInt(card.dataset.colorIndex, 10), card.dataset.productTags);
  }, true);

  window.FS.VariantPopup = { open: open };
  window.FS.initVariantPopup = initVariantPopup;
})();
